import React, { useEffect, useState } from 'react'
import { useIntl } from 'react-intl'
import { useNavigation, useAccountOrders } from 'msp-integrations'
import {
  DynamicTag,
  Button,
  PageActionPlaceHolder,
  Spinner
} from 'msp-components'
import AccountOrderHistoryItem from './AccountOrderHistoryItem/AccountOrderHistoryItem'
import translations from './AccountOrderHistory.constants'
import * as S from './AccountOrderHistory.styles'

const AccountOrderHistoryNoOrders = () => {
  const navigate = useNavigation()
  const { formatMessage } = useIntl()

  return (
    <PageActionPlaceHolder
      iconName='Receipt'
      heading={formatMessage(translations.placeholderHeading)}
      text={formatMessage(translations.placeholderText)}
      buttonText={formatMessage(translations.placeholderCTAText)}
      onButtonClick={() => navigate('/shop')}
    />
  )
}

const AccountOrderHistory = () => {
  const { formatMessage } = useIntl()
  const [hasMoreOrders, setHasMoreOrders] = useState(false)
  const [searchParams] = useState({ limit: 10, offset: 0 })
  const { orderIds, ordersById, isLoading, fetchOrders, paging } =
    useAccountOrders()

  useEffect(() => {
    if (paging.offset !== searchParams.offset || searchParams.offset === 0) {
      fetchOrders(searchParams)
    }
  }, [searchParams.offset])

  useEffect(() => {
    if (paging && paging.total > paging.limit + paging.offset) {
      setHasMoreOrders(true)
    } else {
      setHasMoreOrders(false)
    }
  }, [paging])

  const loadMoreOrders = () => {
    if (hasMoreOrders) {
      const loadMoreParams = {
        limit: paging.limit,
        offset: paging.limit + paging.offset
      }

      fetchOrders(loadMoreParams)
    }
  }

  return (
    <div className={S.MainWrapper}>
      <DynamicTag
        componentTagName='Headline'
        tag='h2'
        tagStyle='h6'
        className={S.Headline}
      >
        {formatMessage(translations.myOrders)}
      </DynamicTag>
      {isLoading && <Spinner />}
      {!isLoading && orderIds.length === 0 && <AccountOrderHistoryNoOrders />}
      {orderIds.length > 0 && (
        <>
          <div className={S.TotalOrders}>
            {formatMessage(translations.totalOrders, {
              nbOrders: paging.total
            })}
          </div>
          <div className={S.ListWrapper}>
            {orderIds.map((orderId: string) => (
              <AccountOrderHistoryItem
                key={`order-${orderId}`}
                order={ordersById[orderId]}
              />
            ))}
          </div>
          {hasMoreOrders && (
            <Button
              className={S.LoadMoreButton}
              type={'primary'}
              isLoading={isLoading}
              loadingContent={<Spinner />}
              iconName={'ArrowRightStick'}
              iconPosition='right'
              onClick={() => loadMoreOrders()}
            >
              {formatMessage(translations.loadMore)}
            </Button>
          )}
        </>
      )}
    </div>
  )
}

AccountOrderHistory.getTemplateName = () => 'account-order-history'

export default AccountOrderHistory
